
/* injects from baggage-loader */

import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { ToastContainer, toast } from "react-toastify";
import promiseMiddleware from "redux-promise";
import { createStore, applyMiddleware, compose } from "redux";
import { autoRehydrate } from "redux-persist";
import { browserHistory, hashHistory } from "react-router";
import allReducers from "../reducers/";
import Bootstrap from "./bootstrap";
import Config from "../config/main";
import { gaMiddleWare } from "../helpers/analytics";
import { syncHistoryWithStore } from "react-router-redux";
import handleCashoutUpdate from "../middleware/handleCashoutUpdate";
import popupsMiddleware from "../middleware/popupsMiddleware";
import simplifySwarmData from "../middleware/simplifySwarmData";
import handleApiIntegrationPartnersActions from "../middleware/apiIntegartionActionSubscriber";
import RouterBuilder from "../components/router/index";
import Loader from "../terminal/components/loader";
import betSlipUpdateHandler from "../middleware/betslipUpdateHandler";
import { LOGGED_IN, UI_CLOSE, UI_OPEN } from "../actions/actionTypes/index";
import Helpers from "../helpers/helperFunctions";
import { UIClose } from "../actions/ui";
import terminalMiddleWare from "../middleware/terminalMiddleware";
import Honeybadger from "honeybadger-js";
import ErrorBoundary from "@honeybadger-io/react";
import { FavoritesContextProvider } from "../contexts/favorites";
import { PartnerStreamsContextProvider } from "../contexts/partnerStreams";
import { checkForWebsitePass } from "../helpers/secure";

//---------------------- Require skin custom JS if present
// const req = require.context("../../skins/" + __SKIN__ + "/mobile/", false, /^\.js\/index\.js$/);
const req = require.context("../../skins/" + __SKIN__ + "/terminal/", true, /^\.\/js\/index\.js$/);
Config.env.skinExports = req.keys().indexOf("./js/index.js") !== -1 ? req("./js/index.js") : {};

//---------------------- Require default CSS
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(require.context("../terminal/scss/defaults", true, /^.*\.scss$/)); // all default scss

const composeEnhancers =
	process.env.NODE_ENV === "development" ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

let middlewares = [
	terminalMiddleWare,
	thunk,
	promiseMiddleware,
	handleCashoutUpdate,
	popupsMiddleware,
	gaMiddleWare,
	simplifySwarmData,
	betSlipUpdateHandler,
];

if (Helpers.CheckIfPathExists(Config, "isPartnerIntegration.mode.iframe")) {
	middlewares.push(handleApiIntegrationPartnersActions);
	Helpers.addClassName(".main-wrapper", "integration-view");
}
Config.main.enableTabletVersion && Helpers.addClassName(".main-wrapper", "has-tablet-view");
export const store = createStore(allReducers, composeEnhancers(applyMiddleware(...middlewares), autoRehydrate()));

checkForWebsitePass().then(() => {
	// Do the app bootstrapping and inform store that application is ready to run
	// Layout component will render it's children only when application is ready
	Bootstrap(store);

	let lastPosition;
	store.subscribe(() => {
		let { uiState, lastAction } = store.getState();
		Helpers.replaceClassName(".main-wrapper", uiState.currentRouteType, uiState.lastRouteType);
		switch (true) {
			case lastAction.type === UI_OPEN && Helpers.setClassOnBodyUI(uiState.opened):
				if (
					uiState.opened &&
					uiState.opened.rightMenu &&
					lastAction.type === UI_OPEN &&
					lastAction.key === "leftMenu"
				) {
					store.dispatch(UIClose("rightMenu"));
				}
				if (
					!(
						Helpers.existClassName("body", "opened-ui") &&
						Helpers.existClassName(".main-wrapper", lastAction.key)
					)
				) {
					lastPosition = window.scrollY;
					Helpers.addClassName("body", "opened-ui");
					// Config.main.homePageSettings && Config.main.homePageSettings.version === 2
					//     ? lastAction.key !== 'rightMenu' && Helpers.addClassName(".main-wrapper", lastAction.key)
					//     : Helpers.addClassName(".main-wrapper", lastAction.key);
					if (
						Config.main.homePageSettings &&
						Config.main.homePageSettings.enableNewLoginRegistration
					) {
						if (
							lastAction.key === "rightMenu" ||
							lastAction.key === "registrationForm"
						) {
							Helpers.addClassName(".wrapper-m", "rightMenu");
						} else {
							Helpers.addClassName(".main-wrapper", lastAction.key);
						}
					} else {
						Helpers.addClassName(".main-wrapper", lastAction.key);
					}
					// lastAction.key !== 'rightMenu' && Helpers.addClassName(".main-wrapper", lastAction.key)
				}
				break;
			case lastAction.type === UI_CLOSE:
				if (
					(Helpers.existClassName("body", "opened-ui") &&
						Helpers.existClassName(".main-wrapper", lastAction.key)) ||
					Helpers.existClassName(".wrapper-m", lastAction.key)
				) {
					Helpers.removeClassName("body", "opened-ui");
					Helpers.removeClassName(".main-wrapper", lastAction.key);
					Helpers.removeClassName(".wrapper-m", lastAction.key);
					setTimeout(() => {
						window.scrollTo(0, lastPosition);
					});
				}
				break;
			case lastAction.type === LOGGED_IN:
				store.dispatch(UIClose("rightMenu"));
				break;
			default:
				break;
		}
	});

	Honeybadger.configure({
		apiKey: "850ad44d",
		environment: process.env.NODE_ENV,
	});

	Honeybadger.setContext({
		Terminal_Id: sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem("authData")).tid,
		Partner_Id: sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem("authData")).pid,
	});

	const appHistory = syncHistoryWithStore(Config.main.useBrowserHistory ? browserHistory : hashHistory, store);
	let inited,
		unsubscribe = store.subscribe(() => {
			switch (true) {
				case store.getState().appReady:
					unsubscribe();
					const { isAsian, startupSettings } = store.getState().terminal;
					// checkSportsBookView(false, false, store.getState().preferences.geoData).isAsian && Helpers.addClassName(".main-wrapper", "asian-view");
					isAsian && Helpers.addClassName(".main-wrapper", "regionClosed");
					startupSettings?.HideLogo && Helpers.addClassName(".main-wrapper", "hideLogo");
					ReactDOM.render(
						<ErrorBoundary honeybadger={Honeybadger}>
							<ToastContainer
								position="top-right"
								autoClose={30000}
								hideProgressBar={false}
								newestOnTop={true}
								closeOnClick
								rtl={false}
								pauseOnHover
							/>
							<Provider store={store}>
								<PartnerStreamsContextProvider>
									<FavoritesContextProvider>
										<RouterBuilder
											store={store}
											appHistory={appHistory}
										/>
									</FavoritesContextProvider>
								</PartnerStreamsContextProvider>
							</Provider>
						</ErrorBoundary>,
						document.getElementById("root")
					);
					break;
				case !inited:
					inited = true;
					ReactDOM.render(
						<Loader component="terminalApp" />,
						document.getElementById("root")
					);
					break;
				default:
					break;
			}
		});
});
